export default __webpack_public_path__ + "static/favicon-0e0cf29433790053a884a34a5db010d9.ico";